// export const API_BASE_URL = "http://localhost:8443";
export const API_BASE_URL = "https://www.magixerp.in:8443";
